<template>
  <section>
    <div class="container">
      <custom-title-block :title="title" />
      <type-uav-block :content="typeUAV" />
      <custom-button-join />
    </div>
  </section>
</template>

<script>
import CustomTitleBlock from "@/components/UI/CustomTitle.vue";
import TypeUavBlock from "@/components/main/aboutUAV/modules/AboutUAVContentBlock.vue";
import CustomButtonJoin from "@/components/UI/CustomButtonJoin.vue";

export default {
  name: "about-uav",
  components: { CustomButtonJoin, TypeUavBlock, CustomTitleBlock },
  data() {
    return {
      title: "ПРО БЕЗПІЛОТНІ СИСТЕМИ",
      typeUAV: [
        {
          title: "Побачити",
          description:
            "Інформація – це зброя. БпЛА виявляють противника, корегують " +
            "артилерію та виконують завдання спільно з ударними дронами",
        },
        {
          title: "Зупинити",
          description:
            "Дистанційне мінування дронами обмежує рухи противника, " +
            "сповільнює та зупиняє його пересування",
        },
        {
          title: "Уразити",
          description:
            "FPV, бомбери та наземні турелі точно і швидко знищують об’єкти " +
            "противника на землі і в повітрі",
        },
        {
          title: "Забезпечити",
          description:
            "Логістичні дрони знімають навантаження з людей та виконують " +
            "доставку в найскладніших умовах",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-bottom: 60px;
}
</style>
